module.exports = __webpack_public_path__ + "static/media/sussman_vince.5fd153cc.png";